module.exports = __webpack_public_path__ + "static/media/eset_logo.f7beec97.png";